module.exports = __webpack_public_path__ + "img/jiance.dcc45f4b.png";